<!-- Zweck: Stellt die HTML-Struktur für dashboard widgets news component im Frontend bereit. -->
<dashboard-widget>
  <div icon>
    <svg-icon>news</svg-icon>
  </div>
  <div header1 matTooltip="News">
    News
  </div>
  <div header2>
    @if ((loading1|async) || (loading2|async)) {
      <mat-spinner [diameter]="20"></mat-spinner>
    }
  </div>
  <div header3>
    <mat-form-field style="width: 80px" appearance="outline" matTooltip="Maximale Anzahl">
      <mat-select (selectionChange)="changeLimit()" [(value)]="limit" placeholder="">
        @for (l of limits; track l) {
          <mat-option [value]="l">{{l}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div content>
    @if ((tags|async) && ((tags|async)?.length > 1 || getTags().length > 0)) {
      <div class="filter">
        @for (tag of tags|async; track tag) {
          <span (click)="toggleTag(tag)"
            [class.active]="selected_tags[tag.id] == true" [style.color]="tag_colors[tag.id]"
          style="cursor:pointer;">{{tag.name}}</span>
        }
      </div>
    }
    @for (e of (data|async)?.data; track e) {
      <div class="newsboxentry">
        <app-dashboard-widgets-news-entry [entry]="e" [tag_colors]="tag_colors"
        [tags]="tags|async"></app-dashboard-widgets-news-entry>
      </div>
    }
    @if (!(loading1 || loading2) && (!(data|async) || (data|async)?.count == 0)) {
      <div>
        <h3>Derzeit nichts Neues!</h3>
      </div>
    }
  </div>
</dashboard-widget>
